import * as svg from "../../../assets/copy.svg";

import {iconBuilder} from "./iconBuilder";

const CopyIcon = iconBuilder(svg, "Copy", "0 0 10 10");

export default CopyIcon;
